import React,{useState,useEffect} from "react";
import api from "../../../api/api";
import Swal from "sweetalert2";

import {
UploadOutlined
} from "@ant-design/icons";

import {
Form,
Input,
Select,
Button,
Card,
Row,
Col,
Typography,
DatePicker,
Upload,
Divider
} from "antd";

import {
UserAddOutlined,
BookOutlined,
IdcardOutlined
} from "@ant-design/icons";

import dayjs from "dayjs";
import "./AdmissionForm.css";

const {Title,Text}=Typography;
const {Option}=Select;

const emptyStudent={
user:"",
full_name:"",
gender:"",
previous_class:"",
grade_class:"",
division_assigned:"",
major_subject:"",
previous_school:"",
hobit:"",
date_of_birth:"",
address:"",
mother_name:"",
father_name:"",
health_status:"",
parent_contact:"",
enrollment_date:"",
semester_status:"",
status:"",
student_status:"",
nationality:"",
parent_id:"",
academic_year:"",
county_of_origin:""
};

const AdmissionForm=()=>{

const [form]=Form.useForm();

const [student,setStudent]=useState(emptyStudent);
const [academicYears,setAcademicYears]=useState([]);
const [grades,setGrades]=useState([]);
const [divisions,setDivisions]=useState([]);
const [superParents,setSuperParents]=useState([]);
const [users,setUsers]=useState([]);
const [loading,setLoading]=useState(false);

const token=localStorage.getItem("access");

const config={
headers:{
Authorization:`Bearer ${token}`
}
};


useEffect(()=>{
loadAcademicYears();
loadGrades();
loadDivisions();
loadSuperParents();
loadStudentsUsers();
},[]);


const loadAcademicYears=async()=>{
try{
const res=await api.get("/academic-years/",config);
setAcademicYears(res.data||[]);
}catch(error){
console.log(error);
}
};


const loadGrades=async()=>{
try{
const res=await api.get("/api/users/grade-classes/",config);
setGrades(res.data||[]);
}catch(error){
console.log(error);
}
};


const loadDivisions=async()=>{
try{
const res=await api.get("/api/users/divisions/",config);
setDivisions(res.data||[]);
}catch(error){
console.log(error);
}
};


const loadSuperParents=async()=>{
try{
const res=await api.get("/api/super-parents/",config);
setSuperParents(res.data||[]);
}catch(error){
console.log(error);
}
};


const loadStudentsUsers=async()=>{
try{
const res=await api.get("/api/students/",config);
setUsers(res.data||[]);
}catch(error){
console.log(error);
}
};


const handleSubmit = async (values) => {
  try {
    setLoading(true);
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (key !== "student_admission_image" && value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    if (values.date_of_birth) {
      formData.set("date_of_birth", values.date_of_birth.format("YYYY-MM-DD"));
    }
    if (values.enrollment_date) {
      formData.set("enrollment_date", values.enrollment_date.format("YYYY-MM-DD"));
    }
    if (values.student_admission_image?.length) {
      formData.append("student_admission_image", values.student_admission_image[0].originFileObj);
    }
    await api.post("/api/users/students/", formData, config);
    Swal.fire({
      icon: "success",
      title: "Admission Successful",
      text: "Student has been admitted successfully."
    });
    form.resetFields();
  } catch (error) {
    console.log(error.response?.data);
    Swal.fire({
      icon: "error",
      title: "Admission Failed",
      text: error.response?.data?.detail || "Unable to submit student information"
    });
  } finally {
    setLoading(false);
  }
};

return(

<div className="admission-page">

<Card
className="admission-card"
bordered={false}
>

<div className="admission-header">

<UserAddOutlined className="header-icon"/>

<Title level={2}>
Student Admission Form
</Title>

<Text type="secondary">
School Administration • New Student Registration
</Text>

</div>


<Form
form={form}
layout="vertical"
onFinish={handleSubmit}
className="compact-form"
>


<Divider orientation="left">
<BookOutlined/>
 Academic Information
</Divider>


<Row gutter={[16,10]}>


<Col xs={24} md={12}>

<Form.Item
label="Academic Year"
name="academic_year"
rules={[
{
required:true,
message:"Select academic year"
}
]}
>

<Select
placeholder="Select Academic Year"
className="compact-input"
>

{
academicYears.map(year=>
<Option
key={year.id}
value={year.id}
>
{year.name}
</Option>
)
}

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Grade Class"
name="grade_class"
rules={[
{
required:true,
message:"Select grade class"
}
]}
>

<Select
placeholder="Select Grade Class"
showSearch
optionFilterProp="children"
className="compact-input"
>

{
grades.map(item=>
<Option
key={item.id}
value={item.id}
>
{item.name}
</Option>
)
}

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Student User"
name="user"
>

<Select
showSearch
placeholder="Select Student Account"
optionFilterProp="children"
className="compact-input"
>

{
users.map(user=>
<Option
key={user.id}
value={user.id}
>
{
user.username||
user.full_name||
user.email
}
</Option>
)
}

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Division"
name="division_assigned"
>

<Select
placeholder="Select Division"
className="compact-input"
>

{
divisions.map(item=>
<Option
key={item.id}
value={item.id}
>
{item.name}
</Option>
)
}

</Select>

</Form.Item>

</Col>


</Row>

<Divider orientation="left">
<IdcardOutlined/>
 Student Information
</Divider>


<Row gutter={[16,10]}>


<Col xs={24} md={12}>

<Form.Item
label="Full Name"
name="full_name"
rules={[
{
required:true,
message:"Enter student full name"
}
]}
>

<Input
placeholder="Student full name"
className="compact-input"
/>

</Form.Item>

</Col>







<Col xs={24} md={12}>

<Form.Item
label="County of Origin"
name="county_of_origin"
>

<Input
placeholder="County"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Previous Class"
name="previous_class"
>

<Input
placeholder="Previous class"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Major Subject"
name="major_subject"
>

<Input
placeholder="Major subject"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Previous School"
name="previous_school"
>

<Input
placeholder="Previous school"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Hobby"
name="hobit"
>

<Input
placeholder="Student hobby"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Date of Birth"
name="date_of_birth"
>

<DatePicker
className="compact-input"
placeholder="Select date of birth"
/>

</Form.Item>

</Col>


<Col xs={24} md={12}>

<Form.Item
  label="Student Admission Image"
  name="student_admission_image"
  valuePropName="file"
  getValueFromEvent={(e) =>
    Array.isArray(e) ? e : e?.fileList
  }
>

<Upload
  beforeUpload={() => false}
  maxCount={1}
  accept="image/*"
>

<Button
  icon={<UploadOutlined />}
>
  Select Student Image
</Button>

</Upload>

</Form.Item>

</Col>



<Col xs={24}>

<Form.Item
label="Address"
name="address"
>

<Input.TextArea
rows={2}
placeholder="Student address"
/>

</Form.Item>

</Col>
</Row>



<Divider orientation="left">
<UserAddOutlined/>
 Parent Information
</Divider>



<Row gutter={[16,10]}>


<Col xs={24} md={12}>

<Form.Item
label="Select Parent"
name="parent_id"
>

<Select
showSearch
placeholder="Select Parent"
optionFilterProp="children"
className="compact-input"
>

{
superParents.map(parent=>

<Option
key={parent.id}
value={parent.id}
>

{
parent.username||
parent.full_name||
parent.email
}

</Option>

)

}

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Mother Name"
name="mother_name"
>

<Input
placeholder="Mother name"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Father Name"
name="father_name"
>

<Input
placeholder="Father name"
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
    label="Parent Contact"
    name="parent_contact"
>
    <Input
        placeholder="07734554345/07734453355"
        className="compact-input"
        maxLength={50}
    />
</Form.Item>

</Col>


</Row>

<Divider orientation="left">
Health Information
</Divider>


<Row gutter={[16,10]}>


<Col xs={24} md={12}>

<Form.Item
label="Health Status"
name="health_status"
>

<Input.TextArea
rows={2}
placeholder="Medical information"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Nationality"
name="nationality"
>

<Input
placeholder="Nationality"
className="compact-input"
/>

</Form.Item>

</Col>


</Row>



<Divider orientation="left">
Academic Status
</Divider>



<Row gutter={[16,10]}>


<Col xs={24} md={12}>

<Form.Item
label="Enrollment Date"
name="enrollment_date"
>

<DatePicker
className="compact-input"
/>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Semester"
name="semester_status"
>

<Select
placeholder="Select Semester"
className="compact-input"
>

<Option value="First">
First Semester
</Option>

<Option value="Second">
Second Semester
</Option>

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Student Status"
name="student_status"
>

<Select
placeholder="Student Status"
className="compact-input"
>

<Option value="Regular">
Regular
</Option>

<Option value="Ward">
Dependent
</Option>

<Option value="Scholarship Student">
Scholarship Student
</Option>

</Select>

</Form.Item>

</Col>



<Col xs={24} md={12}>

<Form.Item
label="Enrollment Status"
name="status"
>

<Select
placeholder="Enrollment Status"
className="compact-input"
>

<Option value="Pending">
Pending
</Option>

<Option value="Enrolled">
Enrolled
</Option>

<Option value="Graduated">
Graduated
</Option>

<Option value="Dropped">
Dropped
</Option>

</Select>

</Form.Item>

</Col>


</Row>



<Form.Item>

<Button
htmlType="submit"
type="primary"
loading={loading}
className="submit-button"
>

{
loading
?"Submitting Admission..."
:"Submit Student Admission"
}

</Button>

</Form.Item>


</Form>

</Card>

</div>

);

};


export default AdmissionForm;